var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 21H13V6C13 5.20435 13.3161 4.44129 13.8787 3.87868C14.4413 3.31607 15.2044 3 16 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8947 3.48043 22 3.73478 22 4V20C22 20.2652 21.8947 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21ZM11 21H3.00003C2.73481 21 2.48046 20.8946 2.29292 20.7071C2.10539 20.5196 2.00003 20.2652 2.00003 20V4C2.00003 3.73478 2.10539 3.48043 2.29292 3.29289C2.48046 3.10536 2.73481 3 3.00003 3H8.00003C8.79568 3 9.55874 3.31607 10.1214 3.87868C10.684 4.44129 11 5.20435 11 6V21ZM11 21H13V23H11V21Z",
    fill: "#6495ED"
  })));
};
export default SvgBook;